import layout from '@/layout'
// import { _l } from '@/i18n'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/preOrder',
  component: layout,
  meta: {
    funcID: 'F0013',
    PID: 'F00',
  },
  children: ((pre) => [
    {
      path: 'fileComparison',
      name: `${pre}fileComparison`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F001301',
        PID: 'F00',
      },
      component: () => import('@/views/factory/preOrder/fileComparison'),
    },
    {
      path: 'orderFileUpload',
      name: `${pre}orderFileUpload`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F001302',
        PID: 'F00',
      },
      component: () => import('@/views/factory/preOrder/orderFileUpload'),
    },
    {
      path: 'customerOrderGoods',
      name: `${pre}customerOrderGoods`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F001303',
        PID: 'F00',
      },
      component: () => import('@/views/factory/preOrder/customerOrderGoods'),
    },
  ])('preOrder-'),
}
